export default __webpack_public_path__ + "static/media/4bet24_receipt.931cb77e.jpg";